import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
import { GraduationCap, Users, Search, Book, Brain, User } from 'lucide-react';
const audiences = [{
  icon: GraduationCap,
  label: 'Estudiantes'
}, {
  icon: Users,
  label: 'Padres'
}, {
  icon: Search,
  label: 'Personas curiosas'
}, {
  icon: Book,
  label: 'Amantes de la historia'
}, {
  icon: Brain,
  label: 'Crecimiento intelectual'
}, {
  icon: User,
  label: 'Autodidactas'
}];
export function AudienceSection() {
  return <Section background="cream" data-id="element-8">
      <SectionHeader title="¿Para quién es este pack?" subtitle="Diseñado para mentes inquietas que buscan profundidad." data-id="element-9" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6" data-id="element-10">
        {audiences.map((item, index) => <motion.div key={item.label} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="flex flex-col items-center text-center group" data-id="element-11">
            <div className="w-20 h-20 rounded-full bg-white border border-[#E0D8D0] flex items-center justify-center mb-4 shadow-sm group-hover:border-[#C9A227] group-hover:shadow-md transition-all duration-300" data-id="element-12">
              <item.icon className="w-8 h-8 text-[#5C3D2E] group-hover:text-[#C9A227] transition-colors" data-id="element-13" />
            </div>
            <span className="font-medium text-[#3D2314]" data-id="element-14">{item.label}</span>
          </motion.div>)}
      </div>
    </Section>;
}